import React, { useState, useEffect, useRef, useMemo, useCallback } from "react"
import '../styles/index.css'
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

// Eliminamos el wrapper que causaba resets y usamos Pannellum nativo vía window.pannellum
import "pannellum-react/es/pannellum/css/pannellum.css"
import "bootstrap/dist/css/bootstrap.min.css"


import imageprev from "../gifts/almudena_.jpg";
import AlertDialog from './AlertDialog';
import Servicios from './Servicios';
//----------------------------------------------------Fin-------------------------------------------------------------------------------------------------------------------------------------------------------------------------

//Sugerencias de busqueda
//----------------------------------------------------Init-------------------------------------------------------------------------------------------------------------------------------------------------------------------------
import axios from 'axios'
import SearchByLastName from './SearchByLastName';
import SearchByName from './SearchByName';
import SearchByDateDef from './SearchByDateDef';
import SearchByDateNac from "./SearchByDateNac";
import { useImageTour } from '../hooks/useImageTour';
import MapComponent from "./LeafMap";
import ConfirmacionPage from '../pages/ServiciosPago';
import PasarelaPago from '../pages/PasarelaPago';
import { API_URL } from '../helpers/config';

axios.defaults.withCredentials = true;

const MainAppContent = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {

  }, [i18n.language]); // Dependencia en i18n.language para que se dispare si cambia

  const changeLanguage = () => {
    const newLang = i18n.language === 'es' ? 'en' : 'es';
    i18n.changeLanguage(newLang)
      .then(() => {

      })
      .catch(err => {
        console.error("Error al cambiar el idioma", err);
      });
  };

  //setear los hooks usestate
  const [data, setData] = useState([]);

  //Para el autsuggest
  const [selectedLastName, setSelectedLastName] = useState(""); // Apellido seleccionado
  const [nameValue, setNameValue] = useState(""); // Nombre seleccionado
  const [selectedPersonByName, setSelectedPersonByName] = useState([]);
  const nameInputRef = useRef(null);
  const [filteredDates, setFilteredDates] = useState([]);
  const [dateValue, setDateValue] = useState("");
  const [filteredNacDates, setFilteredNacDates] = useState([]);
  const [NacDateValue, setNacDateValue] = useState("");

  const [filtraData, setFiltraData] = useState([]);
  const [selectedServiceImage, setSelectedServiceImage] = useState([]);



  //obtener los datos que queremos mediante una consulta especifica a la bbdd
  const response_databbdd = async (id) => {
    //establezco el loading en true
    setLoading(true)

    //Geojson de fetch  
    const resindication = await fetch(`${API_URL}/indication/${id}`, {
      method: "GET",
      credentials: 'include',
    })
    const datamapsdir = await resindication.json()
    //Lee el geoJSON de forma adecuada pero a la hora de representarlos mediante GeoJSON de leaflet no lo actualiza 
    //Por esa razon hacemos las conversiones necesarias para obtener los puntos donde se representara el camino correcto
    const data_geo = JSON.parse(datamapsdir[0].st_asgeojson.replace('{"type":"LineString","coordinates":', '').replace('}', ''))
    //Para representarlos observamos que la latitud y la longitud estan cambiadas de poscicion por lo que hacemos un bucle para que independientemente de los datos que sean se haga de forma correcta
    for (let i = 0; i < data_geo.length; i++) {
      data_geo.splice(i, 1, [data_geo[i][1], data_geo[i][0]]);
    }

    setMapaInd(data_geo)

    //----------
    const res = await fetch(`${API_URL}/search/${id}`, { //una vez realizada la consulta la traemos en formato json la cual seleccionaremos los valores deseados.
      method: "GET",
      credentials: 'include',
    })
    const datasearh = await res.json()

    //const scena_id2 = datasearh[0].equiimagei.replace('.jpg', "")//filto por nombre de la imagen



    //setMapmaker
    const jsonlat = datasearh[0].longitude
    const jsonlng = datasearh[0].latitude
    const apimap = [jsonlat, jsonlng]
    setMarkerPosition(apimap)

    //setZommAfter
    setZoomAfter(24)

    //setPopinfo
    // eslint-disable-next-line
    const PopInfo = ' Cuartel: ' + datasearh[0].cuartel + ' , ' + ' Manzana: ' + datasearh[0].manzana + ' , ' + ' Letra: ' + datasearh[0].letra
    setPopup(PopInfo)
    // eslint-disable-next-line
    setPopuptittle(datasearh[0].nombre + " " + datasearh[0].apellido1 + " " + datasearh[0].apellido2 + "  || " + datasearh[0].fecha_def);

    //Esto es para la imagen

    pendingSceneRef.current = null; // Resetear payload pendiente antes de nueva carga
    await loadScene(datasearh[0].id)
    setLoading(false)

  }

  //__-------------------------------------------------------------------------------------------------------------------------------------------------------------
  //Pannellum

  const [isPannellumVisible, setPannellumVisible] = useState(false);
  const [showServicios, setShowServicios] = useState(false);
  
  // UseRef para lectura atómica dentro de closures nativos
  const isNavigatingRef = useRef(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");


  // Función para mostrar el pop-up con un mensaje específico
  const displayAlert = (message) => {
    setAlertMessage(message);
    setShowAlert(true);
  };

  const { currentScene, loadScene, handleSceneChange, isLoading, preloadedScenes } = useImageTour(1, displayAlert);

  // Función para cerrar el pop-up
  const handleCloseAlert = () => {
    setShowAlert(false);
    setAlertMessage(""); // Opcional: limpiar el mensaje al cerrar
  };

  useEffect(() => {
    if (location.state?.searchState) {
      const state = location.state.searchState;
      setSelectedLastName(state.selectedLastName || "");
      setNameValue(state.nameValue || "");
      setDateValue(state.dateValue || "");
      setNacDateValue(state.NacDateValue || "");
      setSelectedPersonByName(state.selectedPersonByName || []);
      setData(state.data || []);
      setFiltraData(state.filtraData || []);
    }
    if (location.state?.openServicios) {
      setShowServicios(true);
      setSelectedServiceImage(location.state.restoredSelectedImages || []);
      if (location.state.restoredDifuntoInfo) {
        setPopuptittle(location.state.restoredDifuntoInfo.titulo);
        setPopup(location.state.restoredDifuntoInfo.descripcion);
      }
    }
  }, [location.state]);
  const panRef = useRef(null);
  const panDivRef = useRef(null);
  const vRef = useRef(null);
  const pendingSceneRef = useRef(null); 
  const [isNavigating, setIsNavigating] = useState(false);
  const [viewerReady, setViewerReady] = useState(false);
  const [isInitialPannellumLoad, setIsInitialPannellumLoad] = useState(true);
  const initialImageUrlRef = useRef(null);
  const currentSceneIdRef = useRef(null);
  const currentSceneRef = useRef(null);
  const preloadedScenesRef = useRef([]);
  const dynamicHotspotsRef = useRef([]);

  const visitedHistoryRef = useRef([]);

  // Sincronizar los refs con el estado para que los closures nativos lo vean bien
  useEffect(() => {
    if (currentScene?.id) {
        const sceneIdNum = Number(currentScene.id);
        currentSceneIdRef.current = sceneIdNum;
        
        // Registrar en el historial de navegación para evitar bucles infinitos y permitir deshacer histórico
        const history = visitedHistoryRef.current;
        if (history.length === 0 || history[history.length - 1] !== sceneIdNum) {
            if (history.length > 25) history.shift();
            history.push(sceneIdNum);
        }
    }
    currentSceneRef.current = currentScene;
  }, [currentScene]);
  
  useEffect(() => {
    preloadedScenesRef.current = preloadedScenes;
  }, [preloadedScenes]);



  // Función de emergencia para asegurar que una escena está en el motor ANTES de navegar
  const ensureSceneInEngine = (v, sceneId) => {
    if (!v) return false;
    const config = v.getConfig();
    const idStr = String(sceneId);
    if (config.scenes && config.scenes[idStr]) return true;

    // Si no está, buscarla en la caché y añadirla "en caliente"
    const scenes = preloadedScenesRef.current || [];
    const sceneData = scenes.find(s => Number(s.id) === Number(sceneId));
    if (sceneData) {

        v.addScene(idStr, {
            type: 'equirectangular',
            panorama: sceneData.url,
            pitch: sceneData.pitch,
            yaw: sceneData.yaw,
            hfov: sceneData.hfov
        });
        return true;
    }
    return false;
  };

  // --- LÓGICA DE NAVEGACIÓN SECUENCIAL (-1 / +1) PARA TODOS LOS RECORRIDOS ---
  const handleTourNext = useCallback(async () => {
    const v = vRef.current;
    if (!v || isNavigating) return;
    const sceneId = currentScene?.id;
    if (!sceneId) return;

    const numSceneId = Number(sceneId);
    // Para Nichos (>=100000), Siguiente es +1. Para el resto (búsqueda, tumbas, etc.), Siguiente es -1.
    const nextId = numSceneId >= 100000 ? numSceneId + 1 : numSceneId - 1;
    console.log(`[Tour360] handleTourNext called -> currentSceneId: ${sceneId}, nextId: ${nextId}`);
    if (nextId < 1) {
        displayAlert(t("noMorePhotos"));
        return;
    }

    setIsNavigating(true);
    isNavigatingRef.current = true;

    const initialPitch = currentScene?.pitch ?? 0;
    const initialYaw = currentScene?.yaw ?? 0;
    const initialHfov = currentScene?.hfov ?? 100;

    v.lookAt(initialPitch, initialYaw, initialHfov, 300);

    setTimeout(() => {
        v.lookAt(initialPitch, initialYaw + 8, initialHfov - 6, 900);
    }, 300);

    setTimeout(async () => {
        const loadResult = await loadScene(nextId, 'silent');
        const targetExists = ensureSceneInEngine(v, nextId);
        
        if (!loadResult || !targetExists) {
            displayAlert(t("noMorePhotos"));
            setIsNavigating(false);
            isNavigatingRef.current = false;
            return;
        }

        const nextIdStr = String(nextId);
        const scenes = preloadedScenesRef.current || [];
        const nextSceneData = scenes.find(s => Number(s.id) === nextId);
        
        v.loadScene(
            nextIdStr,
            nextSceneData?.pitch ?? 0,
            nextSceneData?.yaw ?? 0,
            nextSceneData?.hfov ?? 100
        );

        setTimeout(() => {
            setIsNavigating(false);
            isNavigatingRef.current = false;
        }, 1000);
    }, 1200);
  }, [currentScene, isNavigating, loadScene, displayAlert, t]);

  const handleTourBack = useCallback(async () => {
    const v = vRef.current;
    if (!v || isNavigating) return;
    const sceneId = currentScene?.id;
    if (!sceneId) return;

    const numSceneId = Number(sceneId);
    // Para Nichos (>=100000), Anterior es -1. Para el resto (búsqueda, tumbas, etc.), Anterior es +1.
    const backId = numSceneId >= 100000 ? numSceneId - 1 : numSceneId + 1;
    console.log(`[Tour360] handleTourBack called -> currentSceneId: ${sceneId}, backId: ${backId}`);
    if (backId < 1) {
        displayAlert(t("noMorePhotos"));
        return;
    }

    setIsNavigating(true);
    isNavigatingRef.current = true;

    const initialPitch = currentScene?.pitch ?? 0;
    const initialYaw = currentScene?.yaw ?? 0;
    const initialHfov = currentScene?.hfov ?? 100;

    v.lookAt(initialPitch, initialYaw, initialHfov, 300);

    setTimeout(() => {
        v.lookAt(initialPitch, initialYaw - 8, initialHfov - 6, 900);
    }, 300);

    setTimeout(async () => {
        const loadResult = await loadScene(backId, 'silent');
        const targetExists = ensureSceneInEngine(v, backId);

        if (!loadResult || !targetExists) {
            displayAlert(t("noMorePhotos"));
            setIsNavigating(false);
            isNavigatingRef.current = false;
            return;
        }

        const backIdStr = String(backId);
        const scenes = preloadedScenesRef.current || [];
        const backSceneData = scenes.find(s => Number(s.id) === backId);

        v.loadScene(
            backIdStr,
            backSceneData?.pitch ?? 0,
            backSceneData?.yaw ?? 0,
            backSceneData?.hfov ?? 100
        );

        setTimeout(() => {
            setIsNavigating(false);
            isNavigatingRef.current = false;
        }, 1000);
    }, 1200);
  }, [currentScene, isNavigating, loadScene, displayAlert, t]);



  // Capturamos la URL de la primera imagen para el motor nativo
  if (isPannellumVisible && currentScene?.url && !initialImageUrlRef.current) {

    initialImageUrlRef.current = currentScene.url;
  }
  
  // Inicialización del Motor Nativo (Blindado contra React)
  useEffect(() => {
    if (isPannellumVisible && panDivRef.current && !vRef.current && initialImageUrlRef.current) {

        
        try {
            // ID de inicio como string para el motor
            const firstId = String(currentSceneIdRef.current || currentScene?.id || "8");

            vRef.current = window.pannellum.viewer(panDivRef.current, {
                default: {
                    firstScene: firstId,
                    sceneFadeDuration: 1000, // Transición de fundido suave (crossfade)
                    autoLoad: true,
                    showControls: true,
                    showZoomCtrl: true,
                    mouseZoom: true,
                    friction: 0.15,
                    maxHfov: 102.73424832984955,
                    minPitch: -40,
                    compass: true
                },
                scenes: {
                    [firstId]: {
                        type: 'equirectangular',
                        panorama: initialImageUrlRef.current,
                        pitch: currentScene?.pitch ?? 0,
                        yaw: currentScene?.yaw ?? 0,
                        hfov: currentScene?.hfov ?? 100
                    }
                }
            });

            vRef.current.on('load', () => {
                const viewer = vRef.current;
                if (!viewer) return;
                

                setViewerReady(true);
                setIsInitialPannellumLoad(false);
                
                // Forzar redimensionamiento
                setTimeout(() => { try { viewer.resize(); } catch(e) {} }, 100);
            });

            vRef.current.on('scenechange', (id) => {

            });

        } catch (error) {
            console.error(`[NATIVE_ENGINE] Error de arranque:`, error);
        }
    }
  }, [isPannellumVisible, !!initialImageUrlRef.current]);

  // Sincronización de Escenas Precargadas
  useEffect(() => {
    const v = vRef.current;
    if (!v || !preloadedScenes.length) return;

    // Obtener escenas ya registradas en el motor
    const config = v.getConfig();
    const existingScenes = Object.keys(config.scenes || {});
    const currentActiveScene = v.getScene();

    // 1. Añadir escenas nuevas que están en la caché pero no en el motor
    preloadedScenes.forEach(scene => {
      if (!existingScenes.includes(String(scene.id))) {

        v.addScene(String(scene.id), {
          type: 'equirectangular',
          panorama: scene.url,
          pitch: scene.pitch,
          yaw: scene.yaw,
          hfov: scene.hfov
        });
      }
    });
  }, [preloadedScenes]);


  // GESTIÓN DE CICLO DE VIDA DEL MOTOR (Reseteo y Cierre)
  useEffect(() => {
    if (!isPannellumVisible) {
        if (vRef.current) {
            try { vRef.current.destroy(); } catch(e) {}
            vRef.current = null;
        }
        initialImageUrlRef.current = null;
        setViewerReady(false);
    }
  }, [isPannellumVisible]);

  // SINCRONIZACIÓN DINÁMICA DE ESCENA EN EL MOTOR (Visitar Sepultura, Nichos, Tumbas)
  useEffect(() => {
    const v = vRef.current;
    if (!currentScene?.id) return;

    if (currentScene.url) {
      initialImageUrlRef.current = currentScene.url;
    }

    if (v) {
      const targetIdStr = String(currentScene.id);
      const activeSceneInViewer = String(v.getScene());

      if (activeSceneInViewer !== targetIdStr) {
        console.log(`[Tour360] Syncing viewer to new scene: ${targetIdStr} (was ${activeSceneInViewer})`);
        ensureSceneInEngine(v, currentScene.id);
        try {
          v.loadScene(
            targetIdStr,
            currentScene.pitch ?? 0,
            currentScene.yaw ?? 0,
            currentScene.hfov ?? 100
          );
        } catch (e) {
          console.error("Error switching scene in Pannellum:", e);
        }
      }
    }
  }, [currentScene]);

  const handleSceneChangeRef = useRef(handleSceneChange);
  useEffect(() => {
    handleSceneChangeRef.current = handleSceneChange;
  }, [handleSceneChange]);




  // (Eliminado listener de escena antiguo ya integrado en la inicialización nativa)



  //__---------------------------------------------------------------------------FIN Scene----------------------------------------------------------------------------------


  //__---------------------------------------------------------------------------INIT Mapa-React----------------------------------------------------------------------------------
  //Esto es un Hook para los datos e ir cambiando el mapa
  //estos se actualizarán cuando se acceda a la información del apisql
  const [isMapVisible, setIsMapVisible] = useState(true);
  const marker = [40.422370845484956, -3.6442556998781432]//Ubicacion inicial
  const [markerPosition, setMarkerPosition] = useState(marker);//hook para el marker inicial y el centrado de los markers posteriores
  const [zoomBefore, setZoomAfter] = useState(16.3);//hook para mover el mapa al punto zoom inicial
  const [popup, setPopup] = useState()//hook para establecer datos del pop up
  const [tittlepopup, setPopuptittle] = useState()//hook para establecer titulo del pop up
  const mark = [[-3.645953566, 40.425612396], [-3.645919956, 40.425554829]]
  const [mapaind, setMapaInd] = useState(mark)
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.openServicios) {
      setShowServicios(true);
      if (location.state.restoredSelectedImages) {
        setSelectedServiceImage(location.state.restoredSelectedImages);
      }
      if (location.state.restoredDifuntoInfo) {
        setPopuptittle(location.state.restoredDifuntoInfo.titulo);
        setPopup(location.state.restoredDifuntoInfo.descripcion);
      }
      setPannellumVisible(false);
      setIsMapVisible(false);
      
      // Limpiar el estado del historial para que si el usuario recarga la página no vuelva a abrirse
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const isFloatContentVisible = isPannellumVisible || showServicios || isMapVisible;

  //__---------------------------------------------------------------------------FIN Mapa-React----------------------------------------------------------------------------------
  const [loading, setLoading] = useState(false)

  const options = [
    { label: 'Selecciona una opción', value: '' },
    { label: 'Flores', value: 'https://www.funeuskadi.com/img/esp/funeuskadi/ramos-de-flores-para-funeral/ramo%20a.jpg' },
    { label: 'Coronas', value: 'https://www.floreseneltanatorio.es/wp-content/uploads/44-2.webp' },
    { label: 'Marmolistas', value: '' },
  ];

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;

    if (selectedValue) {
      window.open(selectedValue, '_blank');
    }
  };


  // Evento cuando se selecciona un apellido desde SearchByLastName
  const handleLastNameSelection = async (selectedLastNameValue, isSelection = false) => {
    setSelectedLastName(selectedLastNameValue);

    // Si es solo escritura, no hacemos nada más
    if (!isSelection || !selectedLastNameValue) {
      if (!selectedLastNameValue) {
        setFiltraData([]); // Limpiar
      }
      return;
    }

    // Si es una selección del autocompletado, traemos los datos de ese apellido
    try {
      const response = await axios.get(`${API_URL}/?surname=${selectedLastNameValue}&mode=exact`);
      const allDataForSurname = response.data;

      setData(allDataForSurname);
      setFiltraData(allDataForSurname); // Esto alimenta el SearchByName automáticamente

      // Limpiar el input de nombre para nueva búsqueda
      setTimeout(() => {
        if (nameInputRef.current) {
          nameInputRef.current.focus();
          nameInputRef.current.value = "";
          const inputEvent = new InputEvent("input", { bubbles: true, cancelable: true });
          nameInputRef.current.dispatchEvent(inputEvent);
        }
      }, 100);

    } catch (error) {
      console.error("Error fetching full data for surname:", error);
    }
  };


  const handleNameSelection = (newValueOrSelectedPerson) => {

    // Determinar si hemos recibido un objeto persona o un string del input
    if (typeof newValueOrSelectedPerson === 'string') {
      // El usuario está escribiendo o el Autosuggest está actualizando el valor del input
      setNameValue(newValueOrSelectedPerson); // Actualizar el texto del input del nombre


      // Si el input se vacía, o si quieres que las fechas se limpien al empezar a escribir de nuevo
      if (!newValueOrSelectedPerson.trim()) {
        setSelectedPersonByName(null);
        setDateValue({ day: "", month: "", year: "" });
        setNacDateValue({ day: "", month: "", year: "" });
        setFilteredDates([]);
        setFilteredNacDates([]);
      }

      return; // Salir, ya que aún no se ha seleccionado una persona completa
    }

    const selectedPerson = newValueOrSelectedPerson;
    setNameValue(selectedPerson.nombre || ""); // Actualizar el input con el nombre de la persona seleccionada

    // Directamente usar las fechas del objeto 'selectedPerson'
    const defDate = selectedPerson.fecha_def && selectedPerson.fecha_def !== "null" ? selectedPerson.fecha_def : '';
    const nacDate = selectedPerson.fecha_nac && selectedPerson.fecha_nac !== "null" ? selectedPerson.fecha_nac : '';

    setSelectedPersonByName(selectedPerson);

    // Auto-rellenar fechas de defunción
    if (defDate) {
      const [day, month, year] = defDate.split("/");
      setDateValue({ day, month, year });
      setFilteredDates([defDate]);
    } else {
      setDateValue({ day: "", month: "", year: "" });
      setFilteredDates([]);
    }

    // Auto-rellenar fechas de nacimiento
    if (nacDate) {
      const [day, month, year] = nacDate.split("/");
      setNacDateValue({ day, month, year });
      setFilteredNacDates([nacDate]);
    } else {
      setNacDateValue({ day: "", month: "", year: "" });
      setFilteredNacDates([]);
    }
  };




  const validateAndFetch = async () => {
    if (
      !selectedLastName ||
      !nameValue || 
      !dateValue.day || !dateValue.month || !dateValue.year ||
      !NacDateValue.day || !NacDateValue.month || !NacDateValue.year
    ) {
      displayAlert(t("errorAllFields"));
      return false;
    }

    const personToConfirm = selectedPersonByName;
    const formattedDefDate = `${dateValue.day}/${dateValue.month}/${dateValue.year}`;
    const formattedNacDate = `${NacDateValue.day}/${NacDateValue.month}/${NacDateValue.year}`;

    const isDefDateMatch = personToConfirm.fecha_def === formattedDefDate;
    const isNacDateMatch = personToConfirm.fecha_nac === formattedNacDate;

    if (isDefDateMatch && isNacDateMatch) {
      await response_databbdd(personToConfirm.ID);
      return true;
    } else {
      displayAlert(t("datesMismatch"));
      return false;
    }
  };

  const Seleccion = async () => {
    if (await validateAndFetch()) {
      setShowServicios(false);
      setIsMapVisible(false);
      setPannellumVisible(true);
    }
  };


  const handleVisitarSepultura = async () => {
    await Seleccion();
  };
  const handleRutaHastaClick = async () => {
    if (await validateAndFetch()) {
      setPannellumVisible(false);
      setShowServicios(false);
      setIsMapVisible(true);
      document.body.style.overflow = ''; // Desbloquear el scroll
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' }); // Desplazar la vista arriba para no perder la cabecera
      }, 100);
    }
  };
  const reStart = () => {
    // Reiniciar valores de los inputs

    setDateValue({ day: '', month: '', year: '' });
    setNacDateValue({ day: '', month: '', year: '' });
    setSelectedLastName("");
    setNameValue("");

    setPannellumVisible(false);
    setShowServicios(false);
    setIsMapVisible(true);
    
    // Restablecer los datos filtrados y limpieza completa
    setFiltraData([]);
    setData([]);
    setSelectedPersonByName([]);
    setFilteredDates([]);
    setFilteredNacDates([]);
    setSelectedServiceImage([]);

    // Restablecer valores de mapa
    setMapaInd(mark);
    setMarkerPosition(marker);
    setZoomAfter(16.3);
    setPopup(undefined);
    setPopuptittle(undefined);
  };
  const handleService = async () => {
    if (await validateAndFetch()) {
      setPannellumVisible(false);
      setIsMapVisible(false);
      setShowServicios(true)
      setSelectedServiceImage([]);
    }
  };
  const handleImageSelection = (image) => {
    setSelectedServiceImage((prevSelected) => {
      const isSelected = prevSelected.some(
        (selected) => selected.id === image.id
      );

      if (isSelected) {
        // Si ya está seleccionada, la deseleccionamos (la quitamos del array)
        return prevSelected.filter((selected) => selected.id !== image.id);
      } else {
        // Si no está seleccionada, la seleccionamos (la añadimos al array)
        return [...prevSelected, image];
      }
    });
  };
  const handleContinueAndNavigate = () => {
    if (selectedServiceImage.length > 0) {
      if (popup && tittlepopup) {
        navigate('/confirmacion', {
          state: {
            selectedServiceImage: selectedServiceImage,
            mensajeDePrueba: "Prueba1",
            difuntoInfo: {
              titulo: tittlepopup,
              descripcion: popup
            },
            searchState: {
              selectedLastName,
              nameValue,
              dateValue,
              NacDateValue,
              selectedPersonByName,
              data,
              filtraData
            }
          }
        });
      } else {
        displayAlert(t("selectPersonFirst"));
      }
      setShowServicios(false);
    } else {
      displayAlert(t("selectAtLeastOne"));
    }
  };



  return (
    <>
      <div className="main-content-flex">
        {/* Lado Izquierdo: Formulario de Búsqueda */}
        <div className={`form-wrapper ${isFloatContentVisible ? 'form-shifted' : ''}`}>
          {/* Botones Flotantes (fuera del flujo flex) */}
          <div>
            <button
              className="button-lang"
              onClick={changeLanguage}
            >
              ES/EN
            </button>
          </div>
          <div>
            <button className="butto-restart" onClick={reStart}></button>
          </div>

          {/* Fila 1: Apellido y Nombre */}
          <div className="form-row">
            <div className="form-group">
              <label>{t('lastName')}</label>
              <SearchByLastName
                placeholder={t('lastName')}
                data={data}
                value={selectedLastName}
                onSuggestionSelected={handleLastNameSelection}
                onClick={reStart}
              />
            </div>
            <div className="form-group">
              <label>{t('name')}</label>
              <SearchByName
                placeholder={t('name')}
                data={filtraData}
                value={nameValue}
                onSuggestionSelected={handleNameSelection}
                inputRef={nameInputRef}
              />
            </div>
          </div>

          {/* Fila 2: Fechas */}
          <div className="form-row">
            <div className="form-group">
              <label>{t('birthDate')}</label>
              <div className="date-row">
                {/* Día */}
                <SearchByDateNac
                  filteredDates={filteredNacDates?.map((date) => date.split("/")[0]) || []}
                  value={NacDateValue.day || ""}
                  setValue={(day) =>
                    setNacDateValue((prev) => ({ ...prev, day }))
                  }
                  inputProps={{
                    placeholder: t('dd'),
                    style: { width: "90%", height: "40px", paddingLeft: "10.6px", fontSize: "13px" },
                    readOnly: true
                  }}
                />
                {/* Mes */}
                <SearchByDateNac
                  filteredDates={filteredNacDates?.map((date) => date.split("/")[1]) || []}
                  value={NacDateValue.month || ""}
                  setValue={(month) =>
                    setNacDateValue((prev) => ({ ...prev, month }))
                  }
                  inputProps={{
                    placeholder: t('mm'),
                    style: { width: "90%", height: "40px", paddingLeft: "10.6px", fontSize: "13px" },
                    readOnly: true
                  }}
                />
                {/* Año */}
                <SearchByDateNac
                  filteredDates={filteredNacDates?.map((date) => date.split("/")[2]) || []}
                  value={NacDateValue.year || ""}
                  setValue={(year) =>
                    setNacDateValue((prev) => ({ ...prev, year }))
                  }
                  inputProps={{
                    placeholder: t('yyyy'),
                    style: { width: "90%", height: "40px", paddingLeft: "10.6px", fontSize: "13px" },
                    readOnly: true
                  }}
                />
              </div>
            </div>

            <div className="form-group">
              <label>{t('deathDate')}</label>
              <div className="date-row">
                {/* Día */}
                <SearchByDateDef
                  filteredDates={filteredDates?.map((date) => date.split("/")[0]) || []}
                  value={dateValue.day || ""}
                  setValue={(day) =>
                    setDateValue((prev) => ({ ...prev, day }))
                  }
                  inputProps={{
                    placeholder: t('dd'),
                    style: { width: '90%', height: '40px', paddingLeft: "10.6px", fontSize: '13px' },
                    readOnly: true
                  }}
                />
                {/* Mes */}
                <SearchByDateDef
                  filteredDates={filteredDates?.map((date) => date.split("/ Mes")) || []}
                  value={dateValue.month || ""}
                  setValue={(month) =>
                    setDateValue((prev) => ({ ...prev, month }))
                  }
                  inputProps={{
                    placeholder: t('mm'),
                    style: { width: '90%', height: '40px', paddingLeft: "10.6px", fontSize: '13px' },
                    readOnly: true
                  }}
                />
                {/* Año */}
                <SearchByDateDef
                  filteredDates={filteredDates?.map((date) => date.split("/")[2]) || []}
                  value={dateValue.year || ""}
                  setValue={(year) =>
                    setDateValue((prev) => ({ ...prev, year }))
                  }
                  inputProps={{
                    placeholder: t('yyyy'),
                    style: { width: '90%', height: '40px', paddingLeft: "10.6px", fontSize: '13px' },
                    readOnly: true
                  }}
                />
              </div>
            </div>
          </div>

          {/* Botones */}
          <div className="button-group">
            <button onClick={handleService}>{t('services')}</button>
            <button onClick={handleRutaHastaClick}>{t('navigate')}</button>
            <button onClick={handleVisitarSepultura}>
              {loading ? <b>{t('loading')}</b> : t('visitBurial')}
            </button>
          </div>
        </div>

        {/* Lado Derecho: Contenedor para Mapa / Visor 360 / Servicios */}
        <div className="right-panel-container">
          {isPannellumVisible && (
            <div className="pannellum-float">
              {isInitialPannellumLoad && (
                <div className="nav-loading-overlay">
                  <div className="spinner-border text-light" role="status"></div>
                  <p>{t('loading')} Tour 360...</p>
                </div>
              )}
              
              <button className="mobile-close-btn" onClick={() => setPannellumVisible(false)}>✖</button>
              
              <div className={`pannellum-wrapper ${viewerReady ? 'ready' : ''}`}>
                <div 
                  id="pannellum-container" 
                  ref={panDivRef} 
                  style={{ width: "100%", height: "100%" }}
                />

                {/* OVERLAYS DE NAVEGACIÓN FIJOS (SCREEN SPACE) */}
                {viewerReady && !isInitialPannellumLoad && (
                  <div className="tour-ui-overlay">
                    <button 
                      className={`nav-btn btn-left ${isNavigating ? 'nav-disabled' : ''}`}
                      onClick={handleTourBack}
                      disabled={isNavigating}
                    >
                      <img src="https://cdn-icons-png.flaticon.com/512/3298/3298618.png" alt="Siguiente" />
                      <span className="nav-tooltip">{t('Siguiente')}</span>
                    </button>

                    <button 
                      className={`nav-btn btn-right ${isNavigating ? 'nav-disabled' : ''}`}
                      onClick={handleTourNext}
                      disabled={isNavigating}
                    >
                      <img src="https://cdn-icons-png.flaticon.com/512/3298/3298617.png" alt="Anterior" />
                      <span className="nav-tooltip">{t('Anterior')}</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Bloque para los servicios */}
          <Servicios
            show={showServicios}
            onClose={() => { setShowServicios(false); reStart(); }}
            selectedImages={selectedServiceImage}
            onImageSelect={handleImageSelection}
            onContinue={handleContinueAndNavigate}
            popup={popup}
            tittlepopup={tittlepopup}
            displayAlert={displayAlert}
          />

          {/* Componente de Mapa Condicional */}
          {isMapVisible && (
            <div id="map-component" className="mapstyle">
              {/* BOTÓN 'X' SOLO PARA MÓVILES */}
              <button className="mobile-close-btn" onClick={() => setIsMapVisible(false)}>✖</button>
              <MapComponent
                markerPosition={markerPosition}
                zoomBefore={zoomBefore}
                tittlepopup={tittlepopup}
                popup={popup}
                mapaind={mapaind}
                onNavigate={async (imageId) => {
                  await loadScene(imageId);
                  setIsMapVisible(false);
                  setPannellumVisible(true);
                }}
              />
            </div>
          )}
        </div>
      </div>
      <AlertDialog
        message={alertMessage}
        onClose={handleCloseAlert}
      />

    </>

  )
}



function MagicAppear() {
  return (
    <Router>
      <Routes>
        {/* Ruta principal donde se muestra el contenido normal de MagicAppear */}
        <Route path="/" element={<MainAppContent />} />
        {/* Ruta para la página de confirmación */}
        <Route path="/confirmacion" element={<ConfirmacionPage />} />
        <Route path="/pasarela-pago" element={<PasarelaPago />} />
      </Routes>
    </Router>
  );
}

export default MagicAppear;
